import styled, { css } from 'styled-components';

const Form = styled.form``;

const inputStyles = css`
  background-color: ${
    props => props.disabled
      ? props.theme['grey-normal']
      : '#ffffff'
    };
  border: 3px solid ${props => props.theme['grey-normal']};
  border-radius: 6px;
  box-shadow: none;
  color: #000000;
  font-size: ${props => props.theme['font-size-normal']};
  line-height: ${props => props.theme['line-height-normal']};
  padding: 3px;

  &:hover {
    cursor: ${
      props => {
        if (props.disabled) {
          return 'not-allowed';
        }
        if (props.type === 'checkbox' || props.type === 'radio') {
          return 'pointer';
        }
        return 'text';
      }
    };
  }
`;

const Input = styled.input`
  ${inputStyles}
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: ${props => props.horizontal ? 'row' : 'column'};
  margin: 6px 0;
`;

const Label = styled.label`
  font-weight: bold;
  white-space: ${props => props.wrap ? 'normal' : 'nowrap'};
`;

const Select = styled.select`
  ${inputStyles}
`;

const Textarea = styled.textarea`
  ${inputStyles}
`;

export {
  Form,
  Input,
  InputGroup,
  Label,
  Select,
  Textarea,
};
